<template>
  <div>
    <slot></slot>
    <template>
      <ul class="m-upload-list">
        <li v-for="(file,index) in files" class="m-upload-item" :key="index">
          <div @click="handlePreview(file)" class="m-upload-list-title">
            <Icon type="md-document" />
            {{ file.name }}
          </div>
          <Icon
            v-if="!isViewOnly"
            type="ios-close"
            class="m-upload-list-remove"
            @click.native="handleRemove(file, index)"
          ></Icon>
          <transition name="fade">
            <i-progress
              v-if="file.active || file.progress !== '0.00'"
              :stroke-width="2"
              :percent="parsePercentage(file.progress)"
              :status="getStatus(file)"
            ></i-progress>
          </transition>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  name: "cmp-upload-list",
  props: {
    files: {
      type: Array,
      default() {
        return [];
      }
    },
    isViewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},

  methods: {
    handlePreview(file) {
      this.$emit("on-file-preview", file);
    },
    handleRemove(file, index) {
      this.$emit("on-file-remove", { file, index });
    },
    parsePercentage(val) {
      return parseInt(val);
    },
    getStatus(file) {
      if (!file.success && file.error && file.error != "") return "wrong";
      if (file.progress === "100.00") return "success";
      return "normal";
    }
  }
};
</script>

<style scoped lang="stylus">
.m-upload-list {
  .m-upload-item {
    padding: 0 0 4px 0;
    color: #999;
    border-radius: 4px;
    transition: background-color 0.2s ease-in-out;
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid #f3f3f3;

    &:hover {
      background: #f3f3f3;

      >div {
        color: $theme-color;
        cursor: pointer;
        transition: color 0.2s ease-in-out;
      }
    }

    .m-upload-list-title {
      width: 90%;
      float: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .m-upload-list-remove {
      font-size: 18px;
      float: right;
      cursor: pointer;
      float: right;
      margin-right: 4px;
      margin-top: 7px;
      color: #999;
      transition: all 0.2s ease;
    }
  }
}
</style>